import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 overflow-hidden sm:px-6 lg:px-8">
      <div className="mt-8 text-center">
            <p className="text-base text-gray-500">
              API100.io est une solution hébergée en Suisse dans un datacenter écologique qui revalorise 100% de son énergie pour chauffer des bâtiments.
              <a href="https://news.infomaniak.com/infomaniak-inaugure-un-data-center-revolutionnaire-qui-revalorise-100-de-son-energie-pour-chauffer-des-batiments/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-1">En savoir plus</a>
            </p>
          </div>
        <div className="mt-8 flex justify-center space-x-6">
          <Link to="/" className="text-gray-400 hover:text-gray-300">
            Accueil
          </Link>
          <Link to="/cgv" className="text-gray-400 hover:text-gray-300">
            CGV
          </Link>
          <Link to="/cgu" className="text-gray-400 hover:text-gray-300">
            CGU
          </Link>
          <Link to="/privacy-policy" className="text-gray-400 hover:text-gray-300">
            Politique de confidentialité
          </Link>
          <Link to="/mentions-legales" className="text-gray-400 hover:text-gray-300">
            Mentions légales
          </Link>
        </div>
        <p className="mt-8 text-center text-base text-gray-400">
          &copy; {new Date().getFullYear()} API100.io. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
